import { Button } from '@material-ui/core'
import { ContentCopy } from '@mui/icons-material'
import { useEffect } from 'react'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { generatePasswordResetLink } from '../../../actions/userActions'
import { USER_RESET_PASSWORD_LINK_RESET } from '../../../constants/userConstants'
import OverflowTooltip from '../../Tooltip/OverflowTooltip'

interface Props {
  email: string
}

const PasswordResetLink = ({ email }: Props) => {
  const dispatch = useDispatch()

  const { confirmationCode } = useSelector(
    (state: RootStateOrAny) => state.userGeneratePasswordResetLink
  )

  const link = `https://myquality.hexagonmi.com/reset-password/${confirmationCode}`

  const handleClick = () => {
    dispatch(generatePasswordResetLink(email))
  }

  const copyContent = async () => {
    try {
      await navigator.clipboard.writeText(link)
    } catch (err) {
      console.error('Failed to copy: ', err)
    }
  }

  useEffect(() => {
    return () => {
      dispatch({ type: USER_RESET_PASSWORD_LINK_RESET })
    }
  }, [dispatch])

  return (
    <>
      <Button variant="text" color="primary" onClick={handleClick}>
        Generate Password Reset Link
      </Button>

      {confirmationCode && (
        <Button
          variant="text"
          onClick={copyContent}
          endIcon={<ContentCopy />}
          style={{ maxWidth: '100%' }}
        >
          <OverflowTooltip title={link}>Copy Link</OverflowTooltip>
        </Button>
      )}
    </>
  )
}

export default PasswordResetLink
